export default "__VITE_ASSET__CNSehAWR__"